import { type MainTranslationFunction } from '@autone/translations';

import { type APP_NAME } from '../../../../consts';
import { type TableNamesWithCustomColumns } from '../../../../storage/session-storage';
import { type AssortmentCustomColumnsConfigMap } from '../AssortmentCustomColumnsMenu.types';

import { getProductLocationsTableCustomColumnsConfig } from './product-locations-table.config';
import { getProductsTableCustomColumnsConfig } from './products-table.config';
import { getSkuLocationsTableCustomColumnsConfig } from './sku-locations-table.config';

const ASSORTMENT_CUSTOM_COLUMNS_CONFIG: AssortmentCustomColumnsConfigMap = {
  productsTable: getProductsTableCustomColumnsConfig,
  productLocationsTable: getProductLocationsTableCustomColumnsConfig,
  skuLocationsTable: getSkuLocationsTableCustomColumnsConfig,
} as const;

export const getAssortmentCustomColumnsConfig = (
  tableName: TableNamesWithCustomColumns,
  t: MainTranslationFunction<typeof APP_NAME>,
) => {
  return ASSORTMENT_CUSTOM_COLUMNS_CONFIG[tableName](t);
};
